import { SettingsState } from '@library/utils/interfaces/settings-state.interface';
import { createSelector } from '@ngrx/store';
import { UserState } from './user.state';

const userState = (state: SettingsState) => state.user;

export const getUserEmail = createSelector(userState, (state: UserState) => {
  return state.mail;
});

export const getUser = createSelector(userState, (state) => {
  return state;
});

export const getUserAnalytics = createSelector(userState, (state) => {
  return state.app_telemetry;
});

export const getLocale = createSelector(userState, (state) => {
  return state.locale;
});

export const getKeychain = createSelector(userState, (state) => {
  return state.keychain;
});

export const getUserId = createSelector(userState, (state) => {
  return state.id;
});
